import { createApp } from 'vue'
import App from '../app/App.vue'
import router from '../app/routes'
import ArrayUtil from "../app/utils/ArrayUtil";
import TableUtil from "../app/utils/TableUtil";
import LayoutUtil from "../app/utils/LayoutUtil";
import UIUtil from "../app/utils/UIUtil";
import RowRenderer from "../app/views/layout/RowRenderer.vue"
import AuthorizationManager from "../app/managers/AuthorizationManager";
import ahoy from "ahoy.js"
import mitt from 'mitt'
import Trix from "trix"

import SimpleTypeahead from 'vue3-simple-typeahead';
import VueSimpleContextMenu from 'vue-simple-context-menu';

import Rails from "@rails/ujs";
import NotificationUtil from "../app/utils/NotificationUtil";
import FormElement from "../app/views/form/FormElement.vue";
import ComponentUtil from "../app/utils/ComponentUtil";
import IntegrationUtil from "../app/utils/IntegrationUtil";
import AppUtil from "../app/utils/AppUtil";
import ColorUtil from "../app/utils/ColorUtil";
import ThemeUtil from "../app/utils/ThemeUtil";
import FontUtil from "../app/utils/FontUtil";
import RowContainer from "../app/editor/view/RowContainer.vue";
window.Rails = Rails;

import webase from "../app/model"
window.webase = webase
webase.utils.app = new AppUtil()
webase.utils.array = new ArrayUtil()
webase.utils.table = new TableUtil()
webase.utils.layout = new LayoutUtil()
webase.utils.ui = new UIUtil()
webase.utils.component = new ComponentUtil()
webase.utils.auth = new AuthorizationManager()
webase.utils.notification = new NotificationUtil()
webase.utils.integration = new IntegrationUtil()
webase.utils.color = new ColorUtil()
webase.utils.theme = new ThemeUtil()
webase.utils.font = new FontUtil()

webase.eventDispatcher = mitt()
webase.events = ahoy

console.log('Hello from Webase!')
console.log(process.env.NODE_ENV)
console.log('Vite ⚡️ Rails')

if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
  webase.model.isMobile = true
}

function checkAuthentication() {

  if(WEBASE_SYSTEM_ID) {
    webase.model.auth_token = WEBASE_SYSTEM_ID
    webase.model.user_id = WEBASE_INIT_ID
    return true
  }
  else if(window.localStorage.getItem('WEBASE_SYSTEM_ID')) {
    WEBASE_SYSTEM_ID = window.localStorage.getItem('WEBASE_SYSTEM_ID')
    webase.model.auth_token = WEBASE_SYSTEM_ID
    return true
  }

  return false
}


router.beforeEach((to, from, next) => {
  if (to.name === 'sign-in') {
    next()
  }
  else if (to.name !== 'sign-up' && !checkAuthentication()) {

    if(to.query.uuid) {
      next({ name: 'sign-up', query: { uuid: to.query.uuid } } )
    }
    else {
      next({ name: 'sign-up' })
    }
  }
  else {
    next()
  }
})

console.log('Is authenticated? ' + checkAuthentication())

document.addEventListener('DOMContentLoaded', () => {
  const app = createApp(App)
  app.component('vue-simple-context-menu', VueSimpleContextMenu);
  app.component('row-renderer', RowRenderer);
  app.component('row-container', RowContainer);
  app.component('form-element', FormElement);
  app.use(SimpleTypeahead);
  app.use(router)
  app.mount('#app')
})